<template>
  <div class="app-container">
    <!-- 工具栏 -->
    <div class="filter-container">
      <!-- 计算维度-->
      <div class="filter-data">
        <div class="label filter-item">计算维度：</div>
        <el-radio-group class="filter-item" v-model="queryType" size="small" @change="getHeaderList">
          <el-radio-button :label="3">设备</el-radio-button>
          <el-radio-button :label="2">账号</el-radio-button>
          <el-radio-button :label="1">角色</el-radio-button>
        </el-radio-group>
      </div>
      <div class="filter-data">
        <!-- 分析粒度 -->
        <div class="label filter-item">分析粒度：</div>
        <el-radio-group class="filter-item" v-model="dateType" size="small" @change="getHeaderList">
          <el-radio-button label="day">分天</el-radio-button>
          <el-radio-button label="month">分月</el-radio-button>
          <el-radio-button label="all">汇总</el-radio-button>
        </el-radio-group>
        <el-date-picker  unlink-panels v-if="dateType === 'day' || dateType === 'all'" class="dataPicker filter-item" :clearable="false" size="small" v-model="dayTimes" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
          range-separator="-" :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期" @change="getHeaderList" style="width:260px"></el-date-picker>
        <el-date-picker  unlink-panels v-else class="dataPicker filter-item" :clearable="false" size="small" v-model="monthTimes" format="yyyy-MM" value-format="yyyy-MM" type="monthrange" range-separator="-"
          :picker-options="pickerMonthOptions" start-placeholder="开始日期" end-placeholder="结束日期" @change="getHeaderList" style="width:260px"></el-date-picker>
      </div>

      <div class="filter-data">
        <div class="label filter-item">数据筛选：</div>
        <div class="">
          <!-- 游戏 带全选 -->
          <!-- <multiple-select class="filter-item" size="small"  key="游戏" v-model="appkeys" collapse-tags filterable clearable placeholder="游戏" :props="{label:'name', value:'appkey'}" style="width:200px;" :optionsList="gameOptions"  @change="getCommonChannel"></multiple-select> -->

          <el-select size="small" class="filter-item" style="width:200px;" v-model="appkeys" multiple collapse-tags filterable clearable placeholder="游戏" @change="getCommonChannel">
            <el-option v-for="item in gameOptions" :key="item.appkey" :label="item.name" :value="item.appkey"></el-option>
          </el-select>

          <!-- 平台 带全选 -->
          <multiple-select class="filter-item" size="small" key="平台" v-model="client_os" collapse-tags filterable clearable placeholder="平台" :props="{label:'name', value:'id'}" style="width:200px;"
            :optionsList="client_osOptions"></multiple-select>

          <!-- <el-select class="filter-item" size="small" v-model="types" multiple collapse-tags filterable clearable placeholder="来源" style="width:200px;">
          <el-option v-for="item in typesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->

          <!-- <el-select class="filter-item" size="small" v-model="media" multiple collapse-tags filterable clearable placeholder="媒体" style="width:200px;">
          <el-option v-for="item in mediaOptions" :key="item.channelCode" :label="item.name" :value="item.channelCode"></el-option>
        </el-select> -->

          <el-cascader class="filter-item" filterable size="mini" v-model="media" :options="mediaOptions" :props="{ multiple: true,expandTrigger: 'hover' }" collapse-tags clearable placeholder="媒体" style="width:200px;"
            :show-all-levels="false"></el-cascader>

          <!-- 媒体账号 带全选 -->
          <multiple-select class="filter-item" size="small" key="媒体账号" v-model="advertiserIds" collapse-tags filterable clearable placeholder="媒体账号" :props="{label:'name', value:'id'}" style="width:200px;"
            :optionsList="advertiserIdsOptionsAll" @visible-change="getFilterData($event,'advertiser_id')" :disabled="media.length==1&&media[0][1]=='huaweiocpd'"></multiple-select>
          <!-- <el-select class="filter-item" size="small" v-model="advertiserIds" multiple collapse-tags filterable :filter-method="filterAdvertiserIds" :reserve-keyword="true" clearable placeholder="媒体账号"
          @visible-change="getFilterData($event,'advertiser_id')" style="width:200px;">
          <el-option v-for="item in advertiserIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->

          <br>
          <!-- 广告组 带全选 -->
          <multiple-select class="filter-item" size="small" key="广告组" v-model="campaignIds" collapse-tags filterable clearable placeholder="广告组" :props="{label:'name', value:'id'}" style="width:200px;"
            :optionsList="campaignIdsOptionsAll" @visible-change="getFilterData($event,'campaign_id')" :disabled="media.length==1&&media[0][1]=='huaweiocpd'"></multiple-select>
          <!-- <el-select class="filter-item" size="small" v-model="campaignIds" multiple collapse-tags filterable :filter-method="filterCampaignIds" :reserve-keyword="true" clearable placeholder="广告组"
          @visible-change="getFilterData($event,'campaign_id')" style="width:200px;">
          <el-option v-for="item in campaignIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->

          <!-- 广告计划 带全选 -->
          <multiple-select class="filter-item" size="small" key="广告计划" v-model="adIds" collapse-tags filterable clearable placeholder="广告计划" :props="{label:'name', value:'id'}" style="width:200px;"
            :optionsList="adIdsOptionsAll" @visible-change="getFilterData($event,'ad_id')"></multiple-select>
          <!-- <el-select class="filter-item" size="small" v-model="adIds" multiple collapse-tags filterable :filter-method="filterAdIds" :reserve-keyword="true" clearable placeholder="广告计划"
          @visible-change="getFilterData($event,'ad_id')" style="width:200px;">
          <el-option v-for="item in adIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->

          <!-- 广告计划 带全选 -->
          <multiple-select class="filter-item" size="small" key="广告创意" v-model="creativeIds" collapse-tags filterable clearable placeholder="广告创意" :props="{label:'name', value:'id'}" style="width:200px;"
            :optionsList="creativeIdsOptionsAll" @visible-change="getFilterData($event,'creative_id')" :disabled="media.length==1&&media[0][1]=='huaweiocpd'"></multiple-select>
          <!-- <el-select class="filter-item" size="small" v-model="creativeIds" multiple collapse-tags filterable :filter-method="filterCreativeIds" :reserve-keyword="true" clearable placeholder="广告创意"
          @visible-change="getFilterData($event,'creative_id')" style="width:200px;">
          <el-option v-for="item in creativeIdsOptions" :key="item.id" :label="item.name+' ['+item.id+']'" :value="item.id"></el-option>
        </el-select> -->

        </div>
      </div>

      <!--分析维度 -->
      <div class="filter-data" style="display:inline-flex">
        <div class="label filter-item">分组维度：</div>
        <el-checkbox-group class="filter-item" v-model="groupBy" size="small" @change="getHeaderList">
          <el-checkbox-button v-for="item in groupByOptions" :key="item.value" :label="item.value"
            :disabled="(groupBy.length >= 3 && groupBy.indexOf(item.value) == -1) || (media.length==1&&media[0][1]=='huaweiocpd'&&(item.value=='campaignId'||item.value=='creativeId'||item.value=='advertiserId'))">{{item.title}}</el-checkbox-button>
        </el-checkbox-group>

        <!-- <el-button class="filter-item" size="small" type="primary" plain icon="el-icon-download" @click="isOpenMore = true" v-if="!isOpenMore">高级</el-button>
        <el-button class="filter-item" size="small" type="primary" plain icon="el-icon-upload2" @click="isOpenMore = false" v-else>关闭</el-button> -->
      </div>

      <!-- 查询 -->
      <div class="filter-data" style="display:inline-flex">
        <el-button class="filter-item" size="small" type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
      </div>

    </div>

    <!-- 数据图标总览 -->
    <el-card class="box-card" shadow="never">
      <!-- <el-tag style="margin-bottom:10rpx;" size="mini" type="danger">此报表中花费来源于广告投放平台绑定过的帐号，请UA同学在投放前绑定投放账号，避免花费数据缺失</el-tag> -->
      <div slot="header" class="clearfix">
        <span style="line-height: 28px;">数据总览 </span>
        <div class="right-box" style="float:right">
          <!-- <el-switch v-model="onlyBdc" active-text="只看BDC" inactive-text="" @change="handleFilter" style="margin: 0 10px"></el-switch> -->
          <!-- <el-switch v-model="notNull" active-text="过滤空数据" inactive-text="" @change="handleFilter" style="margin: 0 10px"></el-switch> -->
          <el-tooltip content="指标说明" placement="top">
            <el-button size="mini" @click="dialogTipsVisible = true">
              <svg-icon icon-class="helps" />
            </el-button>
          </el-tooltip>

          <el-button size="mini" type="primary" @click="handleEditNorm" style="margin: 0 10px">编辑指标</el-button>

          <el-button size="mini" type="info" @click="handleDownloadList">导出任务列表</el-button>
          <el-button size="mini" type="info" @click="handleExport" style="margin-left: 0px;"><i class="el-icon-download">导出</i></el-button>
        </div>

      </div>

      <el-dialog title="导出任务列表" :visible.sync="dialogExportTaskListVisible" width="70%" top="10vh">
        <el-table :data="exportTaskList" v-loading="dialogExportTaskListLoading" :default-sort="{prop: 'createTime', order: 'descending'}" border highlight-current-row height="600" empty-text="无记录">
          <el-table-column property="id" label="任务标示" min-width="300" sortable show-overflow-tooltip></el-table-column>
          <el-table-column property="createTime" label="任务时间" width="200" sortable></el-table-column>
          <el-table-column property="ext01" label="任务名称" min-width="300" sortable show-overflow-tooltip></el-table-column>
          <el-table-column property="ext02" label="执行时间（秒）" width="150" sortable></el-table-column>
          <el-table-column property="status" label="状态" width="100" sortable>
            <template slot-scope="scope">
              <bdc-icon-tag v-if="isBdc && scope.row.status == '0'" variant="orange">初始化</bdc-icon-tag>
              <bdc-icon-tag v-else-if="isBdc && scope.row.status == '1'" variant="main">运行中</bdc-icon-tag>
              <bdc-icon-tag v-else-if="isBdc && scope.row.status == '2'" variant="green">已完成</bdc-icon-tag>
              <bdc-icon-tag v-else-if="isBdc" variant="red">执行失败</bdc-icon-tag>
              <span v-else-if="scope.row.status == '0'" style="color: #f8ac59;font-weight: bold;">初始化</span>
              <span v-else-if="scope.row.status == '1'" style="color: #1ab394;font-weight: bold;">运行中</span>
              <span v-else-if="scope.row.status == '2'" style="color: #1ab394;font-weight: bold;">已完成</span>
              <span v-else style="color: red;font-weight: bold;">执行失败</span>
            </template>
          </el-table-column>
          <el-table-column property="downloadPath" label="操作" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status == '2'">
                <el-link type="primary" :href=scope.row.downloadPath>下载</el-link>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog title="指标说明" :visible.sync="dialogTipsVisible" width="70%" top="10vh">
        <div style="margin-bottom:15px">
          <span style="color: #8b0000;">**特记**</span><br />
          所有字段：凡是"比率"概念的数值，一律显示为*100后的%百分值。不管列名是否显示%字样。<br />
          用户ID类别体系：设备/账号/角色 （根据页面选择的「计算维度」进行区分）。<br />
          汇总行：根据具体的列的含义，进行数据行的汇总计算：如，加和/均值/加权均值。<br />
        </div>
        <el-table :data="gridTipsData" border highlight-current-row height="600">
          <el-table-column property="title" label="指标" width="150"></el-table-column>
          <el-table-column property="desc" label="定义"></el-table-column>
          <el-table-column property="id_type" label="计算维度" width="150"></el-table-column>
        </el-table>
      </el-dialog>

      <!-- 表格 -->
      <el-table class="grayTableTile" size="mini" v-loading="listLoading" :data="tableData.records.result" :cell-class-name="highlightCell" :header-cell-class-name="highlightCell" stripe border
        :summary-method="getSummaries" show-summary empty-text="待查询" @sort-change="handleAgeSortChange">

        <el-table-column v-for="itemtable in tableData.headers" :key="itemtable.id" :label="itemtable.label" :property="itemtable.property" :fixed="itemtable.isFixed" :min-width="itemtable.whidth"
          :sortable="itemtable.sortFlag ? 'custom' : false">
          <template slot-scope="scope">
            <el-image v-if="itemtable.property == 'imgUrl'" style="width: auto; height: 40px; margin:0 auto; ovflow:hidden; cursor: pointer;" :src="scope.row[itemtable.property]" @click="openImage(scope.row.imgUrl)">
              <div slot="error" class="image-slot">
                <span>缺少资源</span>
              </div>
            </el-image>
            <span v-else>{{scope.row[itemtable.property]}}</span>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" @pagination="handleFilterPage" style="margin-top:0" />

    </el-card>

    <!-- 编辑指标 -->
    <norm-filter ref="norm" :sourceData="recordsList" @handleSave="quedingshaixuan"></norm-filter>

    <!-- 大图 -->
    <el-image-viewer v-if="showViewer" :z-index="2020" :on-close="closeViewer" :url-list="[imgUrl]" style="height:100vh;overflow:hidden" />

  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import Pagination from '@/components/Pagination'
import moment from 'moment'
import { find_records, find_groupBy, find_target, find_condition, find_recordsHeader, sync_headerData, find_recordsPreloading, find_CommonChannel, ajax_filterGame, find_recordsTotal, gamelist, reportExport, reportTaskList,find_oneIdConfig  } from '@Sys~/api/sys'
import { ajax_gamelist } from '@Sys~/api/user'
import NormFilter from './components/normFilter'
// import data from '../../../../views/pdf/content'

import MultipleSelect from '@Sys~/components/MultipleSelect'
import BdcIconTag from '@/components/BdcIconTag'

import Store from '@Sys~/store'
const name = Store.getters.currentRoute.name
export default {
  name: name,
  components: { Pagination, NormFilter, ElImageViewer, MultipleSelect, BdcIconTag },
  data() {
    return {
      isOpenMore: true, // 是否显示更多筛选
      dialogTipsVisible: false,
      dialogExportTaskListVisible: false,
      exportTaskList: [],
      gridTipsData: [
        { metric: '花费', desc: '花费', id_type: '设备', title: '花费' },
        { metric: '媒体-展示', desc: '媒体-展示', id_type: '设备', title: '媒体-展示' },
        { metric: '媒体-点击', desc: '媒体-点击', id_type: '设备', title: '媒体-点击' },
        { metric: '媒体-CPM', desc: '媒体-CPM千次展示均价', id_type: '设备', title: '媒体-CPM' },
        { metric: '媒体-CTR', desc: '媒体-CTR点击率', id_type: '设备', title: '媒体-CTR(%)' },
        { metric: '媒体-CPC', desc: '媒体-CPC点击均价', id_type: '设备', title: '媒体-CPC' },
        { metric: '媒体-激活数', desc: '媒体-激活数', id_type: '设备', title: '媒体-激活数' },
        { metric: '媒体-CVR', desc: '媒体-激活率CVR （=激活数/点击数）', id_type: '设备', title: '媒体-CVR(%)' },
        { metric: '媒体-CPI', desc: '媒体-激活成本CPI', id_type: '设备', title: '媒体-CPI' },
        { metric: '媒体-下载量', desc: 'APP下载完成量。用户点击广告并完成app下载的次数，数据来源于媒体后台', id_type: '设备', title: '媒体-下载量' },
        { metric: '媒体-下载率（%）', desc: 'APP下载率。app点击后被下载的比率，计算公式是：下载量/点击量*100%，数据来源于媒体后台', id_type: '设备', title: '媒体-下载率（%）' },
        { metric: '媒体-CPD', desc: 'APP下载成本。广告主为每次下载付出的费用成本，计算公式是：花费/下载量，数据来源于媒体后台', id_type: '设备', title: '媒体-CPD' },
        { metric: '媒体-深度转化费用', desc: '深度转化成本。深度优化目标的转化成本，数据来源于媒体后台', id_type: '设备', title: '媒体-深度转化费用' },
        { metric: '收入', desc: '活跃用户总付费', id_type: '设备、账号、角色', title: '收入' },
        { metric: '激活设备', desc: '首次打开游戏SDK初始化完成的设备。时间点在“新增”设备之前，是相对较浅的前端的转化行为。', id_type: '设备', title: '激活设备' },
        { metric: '新增设备', desc: '有（账号或角色）登陆行为的设备。时间点在“激活”设备之后，是相对较深的服务器端的转化行为。', id_type: '设备', title: '新增设备' },
        { metric: 'CPA', desc: '花费/新增设备数', id_type: '设备', title: 'CPA' },
        { metric: '设备DAU', desc: '日活跃设备数', id_type: '设备', title: '设备DAU' },
        { metric: '新增角色', desc: '新创建的角色数', id_type: '角色', title: '新增角色' },
        { metric: '新增角色成本', desc: '成本消耗/新增角色', id_type: '角色', title: '新增角色成本' },
        { metric: '角色DAU', desc: '日活跃角色数', id_type: '角色', title: '角色DAU' },
        { metric: '新增账号', desc: '新创建的账号数', id_type: '账号', title: '新增账号' },
        { metric: '新增账号成本', desc: '成本消耗/新增账号', id_type: '账号', title: '新增账号成本' },
        { metric: '账号DAU', desc: '日活跃账号数', id_type: '账号', title: '账号DAU' },
        { metric: '新增付费数', desc: '新增用户中的付费数', id_type: '设备、账号、角色', title: '新增付费数' },
        { metric: '新增付费金额', desc: '新增用户带来的付费总金额', id_type: '设备、账号、角色', title: '新增付费金额' },
        { metric: '新增付费率', desc: '新增付费人数/新增人数', id_type: '设备、账号、角色', title: '新增付费率' },
        { metric: '新增付费ARPU', desc: '新增付费金额/新增人数', id_type: '设备、账号、角色', title: '新增付费ARPU' },
        { metric: '新增付费ARPPU', desc: '新增付费金额/新增付费人数', id_type: '设备、账号、角色', title: '新增付费ARPPU' },
        { metric: 'ARPU', desc: '收入/DAU', id_type: '设备、账号、角色', title: 'ARPU' },
        { metric: 'ARPPU', desc: '收入/当日付费人数', id_type: '设备、账号、角色', title: 'ARPPU' },
        { metric: '付费人数', desc: '活跃付费人数', id_type: '设备、账号、角色', title: '付费人数' },
        { metric: '付费渗透率', desc: '活跃付费人数 / DAU', id_type: '设备、账号、角色', title: '付费渗透率(%)' },
        { metric: '付费DAU', desc: '注册之日起有过付费行为的日活跃人数', id_type: '设备', title: '付费DAU' },
        { metric: '留存率-N', desc: '新增设备在激活第N天，活跃数/新增设备', id_type: '设备、账号、角色', title: '留存率(%)-N' },
        { metric: 'LTV-N', desc: '单用户生命周期价值。新增设备在激活起N天内，累计收入/新增设备', id_type: '设备、账号、角色', title: 'LTV-N' },
        { metric: 'ROI-N', desc: '新增设备在激活起N天内，累计收入-N / 花费。汇总行仅统计有完整N天收入和花费的设备。例如：设备A，仅有2天的收入，那么在ROI-3中，则不会统计设备A的收入和花费', id_type: '设备', title: 'ROI-N' },
        { metric: '回本周期', desc: '「总收入>=成本」时所经过的天数', id_type: '设备', title: '回本周期' },
        { metric: '累计收入（查询区间）', desc: '所选时间内新增设备，在新增日期至查询日期区间的截止日期，期间产生的收入总和。例：查询日期为1.1-1.31，累计收入（查询区间）指1.1-1.31内新增的设备，截至1.31日，产生的收入总和。', id_type: '设备', title: '累计收入（查询区间）' },
        { metric: 'ROI（查询区间）', desc: 'ROI（查询区间）= 累计收入（查询区间） ÷ 花费 。例如：查询日期为1.1-1.31，累计收入（查询区间）为统计的是1.1-1.31内新增设备产生的收入总和100元，1.1-1.31日内花费200元，则ROI（截至1.31）=100 ÷ 200 = 0.50 。', id_type: '设备', title: 'ROI（查询区间）' },
        { metric: 'LTV（查询区间）', desc: 'LTV（查询区间）= 累计收入（查询区间）/ 新增用户数', id_type: '设备、账号、角色', title: 'LTV（查询区间）' },
        { metric: 'ROI', desc: 'ROI = 累计收入 / 花费。衡量推广的盈利亏损状态（此处仅指广告推广），ROI＞1，则产品在扣除推广费用后仍处于盈利状态；ROI＜1，则产品收支不平衡，未收回推广成本，仍处于亏损状态。', id_type: '设备', title: 'ROI' },
        { metric: '累计收入', desc: '所选时间内新增设备，自激活日期起至['+moment().subtract(1, 'days').format('YYYY-MM-DD')+']，累计收入。例：用户在5月1日，查询游戏1.1-1.31的数据，累计收入（截至昨日），代表1.1-1.31的新增设备，截至4.30日，产生的收入总和。', id_type: '设备', title: '累计收入' },
        { metric: '累计收入-N', desc: '生命周期累计收入。新增设备在N天内，累计收入', id_type: '设备', title: '累计收入-N' },
        { metric: 'LTV', desc: '累计收入 /  新增用户数', id_type: '设备', title: 'LTV' },
     ],

      queryType: 3, // 计算维度

      dateType: 'day', // 时间范围筛选 天:day, 月：month, all:汇总

      dayTimes: [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")],
      monthTimes: [new Date().Format("yyyy-MM"), new Date().Format("yyyy-MM")],

      // 时间范围 快捷键
      pickerOptions: {
        shortcuts: [
          {
                        text: '今天',
                        onClick(picker) {
                            const end = moment().toDate();
                            const start = moment().toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(1, 'days').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '过去7天',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(7, 'days').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '过去14天',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(14, 'days').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '过去30天',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(30, 'days').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '上周',
                        onClick(picker) {

                        //获取当前时间
                        var currentDate = new Date();
                        //返回date是一周中的某一天
                        var week = currentDate.getDay();
                        //返回date是一个月中的某一天
                        var month = currentDate.getDate();
                        //一天的毫秒数
                        var millisecond = 1000 * 60 * 60 * 24;
                        //减去的天数
                        var minusDay = week != 0 ? week - 1 : 6;
                        //获得当前周的第一天
                        var currentWeekDayOne = new Date(currentDate.getTime() - (millisecond * minusDay));
                        //上周最后一天即本周开始的前一天
                        var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond);
                        //上周的第一天
                        var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6));
                        var sy = priorWeekFirstDay.getFullYear();
                        var sm = priorWeekFirstDay.getMonth();
                        var sd = priorWeekFirstDay.getDate();
                        var ey = priorWeekLastDay.getFullYear();
                        var em = priorWeekLastDay.getMonth();
                        var ed = priorWeekLastDay.getDate();

                        var start = new Date(sy, sm,sd)
                        var end = new Date(ey, em,ed);
                        picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '本月',
                        onClick(picker) {
                            const end = moment().toDate();
                            const start = moment().startOf('month').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '上个月',
                        onClick(picker) {
                            const end = moment().subtract(1, 'month').endOf('month').toDate();
                            const start = moment().subtract(1, 'month').startOf('month').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '近3个月',
                        onClick(picker) {
                            const end = moment().subtract(1, 'days').toDate();
                            const start = moment().subtract(2, 'month').startOf('month').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }
        ],
        // 当前日期之前的日期不可选
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      // 时间范围 月份 
      pickerMonthOptions: {
        // 当前日期之前的日期不可选
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },

      groupBy: [], // 分析维度
      groupByOptions: [],

      appkeys: [], // 当前游戏
      gameOptions: [], // 游戏列表

      media: [], // 当前媒体
      mediaOptions: [], // 媒体列表

      client_os: [], // 当前平台
      client_osOptions: [{ id: 1, name: 'Android' }, { id: 2, name: 'iOS' }], // 平台列表

      advertiserIds: [], // 当前媒体
      advertiserIdsOptions: [], // 媒体列表
      advertiserIdsOptionsAll: [], // 媒体列表总数据

      campaignIds: [], // 当前广告组
      campaignIdsOptions: [], // 广告组列表
      campaignIdsOptionsAll: [], // 广告组列表总数据

      adIds: [], // 当前广告计划
      adIdsOptions: [], // 广告计划列表
      adIdsOptionsAll: [], // 广告计划列表总数据

      creativeIds: [], // 当前广告创意
      creativeIdsOptions: [], // 广告创意列表
      creativeIdsOptionsAll: [], // 广告创意列表总数据

      norm: '', // 当前指标
      normOptions: [], // 指标列表
      symbol: '', // 符号
      symbolOptions: ['=', '!=', '<', '>', '>=', '<='], // 符合列表
      normValue: '',// 指标数值

      typesOptions: [{ id: 1, name: 'BDC' }, { id: 0, name: '其他' }],
      types: [],
      // onlyBdc: true, // 是否只看BDC
      // notNull: false, // 过滤空数据

      listLoading: false,
      tableData: {
        headers: [],
        records: {
          result: []
        },
        recordsSum: {}
      },
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      sortProperty: '',
      sortType: '',

      // 所有指标 
      recordsList: [],

      isFixed: false,
      fixedGroup: ['时间', '素材图'],
      showViewer: false,
      imgUrl: '',

      dialogExportTaskListLoading: false, // 导出任务列表loading
      oneid_info:{},
    }
  },
  created() {
    this.getGroup() // 查询数据维度
    this.getGameList() // 获取游戏列表
    this.getCommonChannel() // 获取公共渠道列表
    this.oneidInit();
    // this.getTarget() // 查询数据筛选可选指标

    // this.getList()
  },

  watch: {
    // 监听时间范围
    dateType(val) {
      // console.log(val)
      if (val == 'day' || val == 'all') {
        this.dayTimes = [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")]
      } else {
        this.monthTimes = [new Date().Format("yyyy-MM"), new Date().Format("yyyy-MM")]
      }
    },

    // 监听分析维度 groupBy 变化
    // groupBy() {
    //     this.appkeys = [] // 当前appkeys
    //     this.advertiserIds = [] // 当前媒体
    //     this.campaignIds = [] // 当前广告组
    //     this.adIds = [] // 当前广告计划
    //     this.creativeIds = [] // 当前广告创意
    // },

    // 监听appks 变化
    appkeys() {
      this.advertiserIds = [] // 当前媒体
      this.campaignIds = [] // 当前广告组
      this.adIds = [] // 当前广告计划
      this.creativeIds = [] // 当前广告创意
    },

     media(val) {
       console.log("val[0][1]",val[0][1])
       if(val.length==1&&val[0][1]=='huaweiocpd'&&(this.groupBy.indexOf('campaignId')>-1||this.groupBy.indexOf('creativeId')>-1||this.groupBy.indexOf('advertiserId')>-1)){
         this.groupBy=[]
       }
       this.advertiserIds = [] // 当前媒体账号
       this.campaignIds = [] // 当前广告组
       this.creativeIds = [] // 当前广告创意
      
    },

    // 监听媒体advertiserIds 变化
    advertiserIds() {
      this.campaignIds = [] // 当前广告组
      this.adIds = [] // 当前广告计划
      this.creativeIds = [] // 当前广告创意
    },

    // 监听当前广告组campaignIds变化
    campaignIds() {
      this.adIds = [] // 当前广告计划
      this.creativeIds = [] // 当前广告创意
    },

    // 监听当前广告计划 adIds 变化
    adIds() {
      this.creativeIds = [] // 当前广告创意
    },

    // 监听source 变化
    source(val) {
      if (val == 1) {
        this.onlyBdc = true
      } else {
        this.onlyBdc = false
      }
    }
  },

  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    }
  },

  methods: {

    // 查询数据维度
    getGroup() {
      find_groupBy().then(response => {
        if (response.code == 1) {
          this.groupByOptions = response.data
          response.data.forEach(item => {
            this.fixedGroup.push(item.title)
          })
        }
      })
    },

    // 查询数据筛选可选指标
    getTarget() {
      find_target().then(response => {
        if (response.code == 1) {
          this.normOptions = response.data
        }
      })
    },

    // 获取游戏列表
    getGameList() {
      gamelist('').then(response => {
        if (response.code == 1) {
          this.gameOptions = response.data
        }
      })
    },

    // 获取公共渠道列表
    getCommonChannel() {
      find_CommonChannel({ appkeys: this.appkeys, projectCode: 'details' }).then(response => {
        if (response.code == 1) {
          // console.log(response.data)
          this.mediaOptions = response.data
        }
      })
    },

    // 查询筛选项
    getFilterData(e, code) {
      if (e) {
        let data = {}
        var media = JSON.parse(JSON.stringify(this.media));
        var mediavalue = [];
        media.forEach(function (item, i) {
          mediavalue.push(item[item.length - 1])
        })

        if (code == 'advertiser_id') { // 查询媒体账号列表
          data = {
            condition: code,
            appkeys: this.appkeys,
            medias: mediavalue
          }

        } else if (code == 'campaign_id') { // 广告组
          data = {
            condition: code,
            appkeys: this.appkeys,
            medias: mediavalue,
            advertiserIds: this.advertiserIds
          }

        } else if (code == 'ad_id') { // 广告计划
          data = {
            condition: code,
            appkeys: this.appkeys,
            medias: mediavalue,
            advertiserIds: this.advertiserIds,
            campaignIds: this.campaignIds
          }

        } else if (code == 'creative_id') { // 广告创意
          data = {
            condition: code,
            appkeys: this.appkeys,
            medias: mediavalue,
            advertiserIds: this.advertiserIds,
            campaignIds: this.campaignIds,
            adIds: this.adIds
          }
        }

        find_condition(data).then(response => {
          if (response.code == 1) {
            if (code == 'advertiser_id') { // 查询媒体账号列表
              this.advertiserIdsOptions = response.data.slice(0, 200)
              this.advertiserIdsOptionsAll = response.data

            } else if (code == 'campaign_id') { // 广告组
              this.campaignIdsOptions = response.data.slice(0, 200)
              this.campaignIdsOptionsAll = response.data

            } else if (code == 'ad_id') { // 广告计划
              this.adIdsOptions = response.data.slice(0, 200)
              this.adIdsOptionsAll = response.data

            } else if (code == 'creative_id') { // 广告创意
              this.creativeIdsOptions = response.data.slice(0, 200)
              this.creativeIdsOptionsAll = response.data
            }
          }
        })
      }
    },

    // 优化 媒体账号 下拉列表数据
    filterAdvertiserIds(val) {
      this.advertiserIdsOptions = this.filterSelect(val, this.advertiserIdsOptionsAll)
    },

    // 优化 广告组 下拉列表数据
    filterCampaignIds(val) {
      this.campaignIdsOptions = this.filterSelect(val, this.campaignIdsOptionsAll)
    },

    // 优化 广告计划 下拉列表数据
    filterAdIds(val) {
      this.adIdsOptions = this.filterSelect(val, this.adIdsOptionsAll)
    },

    // 优化 广告创意 下拉列表数据
    filterCreativeIds(val) {
      this.creativeIdsOptions = this.filterSelect(val, this.creativeIdsOptionsAll)
    },

    filterSelect(val, listAll) {
      let list = []
      if (val) {
        let tok = val.toLowerCase().split(" ")
        list = listAll.filter(item => {
          let matches = 0
          for (var i = 0; i < tok.length; i++) {
            if (String(item['name']).toLowerCase().indexOf(tok[i]) > -1 || String(item['id']).indexOf(tok[i]) > -1) {
              matches++
            }
          }
          if (matches == tok.length) {
            return true
          } else {
            return false
          }
        })
      } else {
        list = listAll.slice(0, 200)
      }
      return list
    },

    // 获取表头
    getHeaderList() {
      var media = JSON.parse(JSON.stringify(this.media));
      var mediavalue = [];
      media.forEach(function (item, i) {
        mediavalue.push(item[item.length - 1])
      })

      
      const data = {
        dateType: this.dateType,
        startDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[0] : this.monthTimes[0],
        endDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[1] : this.monthTimes[1],
        groupBy: this.groupBy,
        appkeys: this.appkeys,
        medias: mediavalue,
        client_os: this.client_os,
        advertiserIds: this.advertiserIds,
        campaignIds: this.campaignIds,
        adIds: this.adIds,
        creativeIds: this.creativeIds,
        dataFilter: this.norm + this.symbol + this.normValue,
        queryType: this.queryType,
        types: this.types,
        //onlyBdc: this.onlyBdc,
        // notNull: this.notNull,
        pageNo: this.listQuery.pageNo,
        pageSize: this.listQuery.pageSize,
        dataSourceFlag:this.oneid_info.dataSource,
      }
      if (!((this.norm && this.symbol && this.normValue) || (!this.norm && !this.symbol && !this.normValue))) {
        this.$message({
          message: '请选择效果指标',
          type: 'error'
        });
        return
      }
      find_recordsPreloading(data).then(response => {
        if (response.code == 1) {
          const data = JSON.parse(JSON.stringify(response.data))
          data.map(v => {
            if (this.fixedGroup.indexOf(v.label) > -1) {
              this.$set(v, 'isFixed', true)
            } else {
              this.$set(v, 'isFixed', false)
            }

            return v
          })

          this.tableData = {
            headers: data,
            records: {
              result: []
            },
            recordsSum: {}
          }
          this.total = 0


        }
      })
    },
    // oneid初始化
    oneidInit() {
      find_oneIdConfig().then(response => {
        if (response.code == 1) {
          this.oneid_info = response.data
        }
      })
    },

    // 获取数据列表
    getList() {

      var media = JSON.parse(JSON.stringify(this.media));
      var mediavalue = [];
      media.forEach(function (item, i) {
        mediavalue.push(item[item.length - 1])
      })

      
      const data = {
        dateType: this.dateType,
        startDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[0] : this.monthTimes[0],
        endDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[1] : this.monthTimes[1],
        groupBy: this.groupBy,
        appkeys: this.appkeys,
        medias: mediavalue,
        client_os: this.client_os,
        advertiserIds: this.advertiserIds,
        campaignIds: this.campaignIds,
        adIds: this.adIds,
        creativeIds: this.creativeIds,
        dataFilter: this.norm + this.symbol + this.normValue,
        queryType: this.queryType,
        types: this.types,
        //    onlyBdc: this.onlyBdc,
        //    notNull: this.notNull,
        pageNo: this.listQuery.pageNo,
        pageSize: this.listQuery.pageSize,

        sortProperty: this.sortProperty, // 排序指标
        sortType: this.sortType, // 排序类型
        dataSourceFlag:this.oneid_info.dataSource,
      }

      if (!((this.norm && this.symbol && this.normValue) || (!this.norm && !this.symbol && !this.normValue))) {
        this.$message({
          message: '请选择效果指标',
          type: 'error'
        });
        return
      }


      this.listLoading = true
      find_records(data).then(response => {
        this.listLoading = false
        if (response.code == 1) {
          this.tableData.records = JSON.parse(JSON.stringify(response.data.records))
          this.tableData.headers = JSON.parse(JSON.stringify(response.data.headers))
          this.tableData.headers.map(v => {
            if (this.fixedGroup.indexOf(v.label) > -1) {
              this.$set(v, 'isFixed', true)
            } else {
              this.$set(v, 'isFixed', false)
            }

            return v
          })
          this.tableData.records.result.map(v => {
            this.$set(v, 'creativeName', (v.creativeName == null ? '' : v.creativeName) + ' [' + v.creativeId + ']')
            return v
          })

          // console.log(this.tableData)
          this.total = response.data.records.totalCount

        }
      })

      find_recordsTotal(data).then(responses => {
        if (responses.code == 1) {
          this.tableData.recordsSum = responses.data.recordsSum
        }
      })

    },

    handleFilterPage() {
      this.getList()
    },

    // 查询
    handleFilter() {
      this.listQuery.pageNo = 1
      this.getList();
    },

    // 合计
    getSummaries(param) {

      var sums = [];
      var zongji = this.tableData.recordsSum;
      var theads = param.columns;
      for (var i = 0; i < theads.length; i++) {
        var istrue = false;
        for (var j in zongji) {
          if (theads[i].property == j) {
            sums.push(zongji[j])
            istrue = true;
          }
        }
        if (!istrue) {
          sums.push("")
        }
      }
      // console.log(sums)
      return sums;
    },

    // 编辑指标
    handleEditNorm() {
      this.$refs['norm'].init()
      this.getRecords()
    },

    // 查询指标
    getRecords() {
      find_recordsHeader().then(response => {
        this.$refs['norm'].loading = false
        if (response.code == 1) {
          // console.log(response)
          const data = JSON.parse(JSON.stringify(response.data))
          data.forEach(arr => {
            let nums = 0;
            arr.children.forEach(item => {
              if (item.checked) {
                nums++
              }
            })

            if (nums == arr.children.length) {
              arr.checked = true
            } else {
              arr.checked = false
            }
          })

          // this.$refs['norm'].sourceData = data
          this.recordsList = data
        }
      })
    },

    // 确定编辑指标
    quedingshaixuan(list) {
      // console.log('====',list)
      const ids = []
      list.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.children.forEach(item => {
            if (item.checked) {
              ids.push(item.id)
            }
          })
        }
      })

      const data = {
        ids: ids,
        projectCode: 'ads_detail'
      }
      // console.log(ids)
      sync_headerData(data).then(response => {
        this.$refs['norm'].dialogLoading = false
        if (response.code == 1) {
          this.$refs['norm'].dialogTableVisible = false
          this.getList();
        }
      })
    },


    // 自定义表头宽度
    labelHead(h, { column, $index }) {
      if (column.property == 'daytime' || column.property == 'monthtime') {
        column.minWidth = 95
      } else if (column.property == 'advertiserName' || column.property == 'gameName') {
        column.minWidth = 120
      } else if (column.property == 'adName' || column.property == 'creativeName') {
        column.minWidth = 220
      } else if (column.property.indexOf('ltv') > -1 || column.property.indexOf('remain') > -1 || column.property.indexOf('roi') > -1) {
        column.minWidth = 85
      } else {
        let len = column.label.length
        let size = 0 //每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，

        if (len == 2) {
          size = 45
        } else if (len == 3) {
          size = 28
        } else if (len >= 4 && len <= 6) {
          size = 22
        } else {
          size = 15
        }
        column.minWidth = size * len //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
      }

      //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h('div', { class: 'table-head', style: { width: '100%' } }, [column.label])

    },

    // 监听排序变化
    handleAgeSortChange(e) {
      console.log(e);
      if (e.order) {
        // const order = e.order == 'ascending' ? 'asc' : 'desc'
        // this.caseTable.sort(sortKeys(e.prop, order))
        this.sortProperty = e.prop
        this.sortType = e.order == 'ascending' ? 'asc' : 'desc'
        this.listQuery.pageNo = 1
        this.getList()
      } else {
        this.sortProperty = ''
        this.sortType = ''
        this.getList()
      }
    },

    // 高亮显示 分析维度组 列
    highlightCell({ row, column, rowIndex, columnIndex }) {
      // console.log(column)
      let className = ['highlight-border']
      this.groupByOptions.forEach(item => {
        if (column.label == item.title) {
          // console.log(item.title)
          className.push('highlight-cell')
        }
      })
      if (column.label == '时间') {
        className.push('highlight-cell')
      }
      // console.log(className)
      return className.join(' ')
    },

    // 打开大图
    openImage(imgUrl) {
      // console.log('打开大图===')
      this.imgUrl = imgUrl
      this.showViewer = true;
    },

    // 关闭图片预览
    closeViewer() {
      // console.log('关闭预览===')
      this.showViewer = false
      this.imgUrl = ''
    },

    handleExport() {
      var media = JSON.parse(JSON.stringify(this.media));
      var mediavalue = [];
      media.forEach(function (item, i) {
        mediavalue.push(item[item.length - 1])
      })

      let st = this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[0] : this.monthTimes[0]
      let et = this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[1] : this.monthTimes[1]
      const data = {
        dateType: this.dateType,
        startDate: st,
        endDate: et,
        groupBy: this.groupBy,
        appkeys: this.appkeys,
        medias: mediavalue,
        client_os: this.client_os,
        advertiserIds: this.advertiserIds,
        campaignIds: this.campaignIds,
        adIds: this.adIds,
        creativeIds: this.creativeIds,
        dataFilter: this.norm + this.symbol + this.normValue,
        queryType: this.queryType,
        types: this.types,
        pageNo: this.listQuery.pageNo,
        pageSize: this.listQuery.pageSize,
        sortProperty: this.sortProperty, // 排序指标
        sortType: this.sortType, // 排序类型

        downloadType: 2,
        downloadTitle: '推广详情(' + st + '~' + et + ')',
        dataSourceFlag:this.oneid_info.dataSource,
      }
      let code = 'download_adsDetailReport'
      reportExport(code, data).then(response => {
        console.log(response)
        this.$message({
          message: '导出任务创建成功，在「导出任务列表」中可以查看进度。',
          type: 'success'
        });
      })
    },

    handleDownloadList() {
      let code = 'find_adsDetailDownloadTask'
      const data = {
        pageNo: 1,
        pageSize: 100,
      }
      this.dialogExportTaskListVisible = true
      this.dialogExportTaskListLoading = true
      reportTaskList(code, data).then(response => {
        this.exportTaskList = response.data
        this.dialogExportTaskListLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  // display: flex;
  // flex-flow: row wrap;
  .filter-data {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    margin: 5px 10px 5px;
  }
  .label {
    min-width: 77px;
    font-size: 15px;
    margin-right: 3px;
    color: #7b7b7b;
  }

  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 74%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }

  ::v-deep .el-cascader__tags {
    .el-tag {
      max-width: 64%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
      }
    }
    .el-cascader__search-input {
      //  margin-left: 2px;
      min-width: 20px;
    }
  }
}

.box-card {
  ::v-deep .el-card__header {
    padding: 6px 20px !important;
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
}

.checkbox-table-headers .el-checkbox {
  min-width: 150px;
}

.grayTableTile ::v-deep .el-table__body-wrapper {
  z-index: 1;
}
.grayTableTile ::v-deep .el-image-viewer__close {
  color: #ffffff;
}

.dataPicker {
  position: relative;
  ::v-deep .el-picker-panel {
    position: absolute;
    top: 32px;
    z-index: 99;
  }
}

.card-box {
  .item {
    margin-bottom: 18px;
  }
  .text {
    font-size: 14px;
  }
  ::v-deep .el-card__body {
    padding: 10px;
  }
}

::v-deep .el-table {
  .highlight-cell {
    background: #d8dde454 !important;
  }

  .highlight-border {
    border-right: 1px solid#f6f7f9 !important;
  }
}

::v-deep .el-image .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 74px;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 12px;
}
</style>
